import { render, staticRenderFns } from "./CNV.vue?vue&type=template&id=2f0c3c4d&scoped=true"
import script from "./CNV.vue?vue&type=script&lang=js"
export * from "./CNV.vue?vue&type=script&lang=js"
import style0 from "./CNV.vue?vue&type=style&index=0&id=2f0c3c4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0c3c4d",
  null
  
)

export default component.exports